import { useTheme } from '@vebox/etui-system';
import { createElement } from 'react';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import TileButton from '../TileButton/TileButton.js';
import RadioBase from './RadioBase.js';

const RadioTile = props => {
  const theme = useTheme();
  return /*#__PURE__*/createElement(RadioBase, props, /*#__PURE__*/createElement(TileButton, {
    title: props.label,
    icon: {
      glyph: props.glyph
    },
    isDisabled: props.isDisabled,
    styles: {
      root: {
        bg: !props.isChecked ? theme.palette.common.white : theme.palette.grey[10],
        color: !props.isChecked ? theme.palette.text.secondary : theme.palette.text.primary,
        borderColor: props.isChecked ? theme.palette.action.activeBorder : theme.palette.divider,
        height: ['90px', '110px']
      }
    }
  }));
};

export default RadioTile;
